/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.product_sections
 */
function priceChartDirective() {
    return {
        restrict: 'E',
        scope: {
            productDetailData: '<?',
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: priceChartController,
        template: require('./priceChartView.html')
    };
}

priceChartController.$inject = [
    'ProductService',
    'UtilService',
    'CmsContentService',
    'DisclosuresModalService',
    'AnalyticsService',
    'AccountAuthService',
    'CookiesService',
    'IndexService',
    'PriceDropService'
];
function priceChartController (
    ProductService,
    UtilService,
    CmsContentService,
    DisclosuresModalService,
    AnalyticsService,
    AccountAuthService,
    CookiesService,
    IndexService,
    PriceDropService
) {
    
    this.$onInit = function () {
        const PRICE_DIRECTION_DROP = "drop";
        const PRICE_DIRECTION_INCREASE = "increase";

        let vm = this;
        vm.likeProduct = likeProduct;
        vm.togglePriceAlert = togglePriceAlert;

        const favProductsModalParamExists = UtilService.isFeatureUrlParamEnabled('signupModal');

        CmsContentService.retrieveCMSValue(vm, 'priceAlertUnfavorite', 'details_page:price_alert_unfavorite');
        CmsContentService.retrieveCMSValue(vm, 'priceAlertFavorite', 'details_page:price_alert_favorite');

        /**
         * Processes price trend's view data
         */
        vm.showPriceDropsChart = ProductService.getDetailsPageConfig('has_price_drops_chart');
        if (vm.showPriceDropsChart) {
            vm.priceChangePointsStr = "";
            var productId = vm.productDetailData.id;
            PriceDropService.getPriceChangeForProducts([productId], false).then(function (data) {
                if (productId in data) {
                    getPriceDropData(data[productId]);
                }
            }, function (error) {
                $log.warn(error);
            });
        }

        vm.isFavoriteProduct = false;
            ProductService.isFavored(vm.productDetailData.id).then(function (isFavored) {
            vm.isFavoriteProduct = isFavored;
            updateFavoriteTooltipText(isFavored);
        });

        function getPriceDropData (data) {
            vm.priceChangePointsStr = data.price_drop_information.coordinates;

            if (vm.priceChangePointsStr === false) {

                vm.showPriceDropsChart = false;

            } else {

                angular.element(document).ready(function () {
                    var priceTrendsGraph = angular.element(document.querySelector('#price-trends-graph'));
                    priceTrendsGraph.attr('points', vm.priceChangePointsStr);
                });

                vm.showPriceDropsChart = true;
                vm.priceDropSideBarInformation = data.price_drop_information;

                if (vm.priceDropSideBarInformation.price_direction === PRICE_DIRECTION_DROP) {
                    CmsContentService.getMarketPlaceText(
                        'details_page:price_alert_dropped_sentence',
                        {
                            'days_ago': vm.priceDropSideBarInformation.days_ago,
                        }
                    ).then(function (text) {
                        vm.priceDropSentence = text;
                    });
                } else if (vm.priceDropSideBarInformation.price_direction === PRICE_DIRECTION_INCREASE) {
                    CmsContentService.getMarketPlaceText(
                        'details_page:price_alert_increased_sentence',
                        {
                            'days_ago': vm.priceDropSideBarInformation.days_ago,
                        }
                    ).then(function (text) {
                        vm.priceDropSentence = text;
                    });
                } else {
                    CmsContentService.getMarketPlaceText('details_page:price_alert_no_change_sentence',).then(function (text) {
                        vm.priceDropSentence = text;
                    });
                }

                const hasSeenFavProductsModalCookie = CookiesService.get('hasSeenFavProductsModalCookie');

                // Once price drop text is set, open favorite products modal if url params present
                if (favProductsModalParamExists && !AccountAuthService.isAuthenticated() && !hasSeenFavProductsModalCookie) {
                    openFavProductsModal();
                }

                vm.priceDropSideBarInformation.price_difference = Math.round(vm.priceDropSideBarInformation.price_difference);
            }
        }

        /**
         * Likes a product based on the product id and refreshed the product data
         * to update the like status of the product.
         * Prompts the user with the sign in form if the user is not logged in.
         * @param productId
         */
        function likeProduct (productId) {
            ProductService.likeProduct(productId, vm.priceDropSentence).then(function () {
                ProductService.isFavored(vm.productDetailData.id, true).then(function (isFavored) {
                    vm.isFavoriteProduct = isFavored;
                    updateDualButton("favorites", 'cmsContent', {dataSectionKey: vm.isFavoriteProduct ? "details_page:price_drop_alerts_added_btn_text" : "details_page:price_drop_alerts_btn_text"} )
                    updateFavoriteTooltipText(isFavored);
                    var eventType = 'product added';
                    if (isFavored) {
                        DisclosuresModalService.openFavoriteProductModal();
                    } else {
                        eventType = 'product removed';
                    }
                    AnalyticsService.reportEvent('Product Favorites Engaged', {
                        type: eventType,
                    }, vm.productDetailData);
                });
            });
        }

        function updateDualButton(buttonType, buttonProperty, buttonPropertyValue) {
            for (var i = 0; i < vm.calloutButtons.length; i++) {
                if (vm.calloutButtons[i].type == buttonType) {
                    vm.calloutButtons[i][buttonProperty] = buttonPropertyValue;
                }
            }
        };

        function updateFavoriteTooltipText(productIsFavored) {
            var favoriteTooltipCmsKey = 'product_card:price_drop_notified_alarm';
            if (productIsFavored) {
                favoriteTooltipCmsKey = 'product_card:price_drop_notified_alarm_active';
            }
            CmsContentService.getMarketPlaceText(favoriteTooltipCmsKey).then(function (favoriteTooltipText) {
                vm.favoriteTooltipText = favoriteTooltipText;
            });
        }

        /**
         * Opens the favorite products modal
         */
        function openFavProductsModal() {
            if (!UtilService.stateIsProduct($state.current.name)) {
                return;
            }

            CookiesService.set('hasSeenFavProductsModalCookie', 'true');
            IndexService.setSignupModalHeaders('fav_product', {priceDropText: vm.priceDropSentence || ''});
            IndexService.openModal('#modal-enter-email');
            vm.likeProduct(vm.productDetailData.id);
        }

        /**
         * Helper function to handle the "create price alert" button being
         * clicked. Sends a tracking event for this specific button, then
         * "likes" the product, which also adds the price alert.
         *
         * @param {Object} e The click event from the DOM
         * @param {Number} productId
         */
        function togglePriceAlert (e, productId) {
            e.stopPropagation();

            vm.likeProduct(productId);
        }

    };

}

module.exports = priceChartDirective;
